<template>
<div class="card-row card-row-show">
<div class="card-row-col card-col wp15">
  {{wallet.create_date | moment('DD MMM YYYY') }}
</div>
 <div class="card-row-col card-col wp15">
  {{wallet.order_no}}
</div>
<div class="card-row-col card-col wp15">
  {{type[wallet.type]}}
</div>
<div class="card-row-col card-col wp15">
  {{wallet.source}}
</div>
<div class="card-row-col card-col wp15">
  {{wallet.destination}}
</div>
<div class="card-row-col card-col wp15">
  {{wallet.amount}}
</div>
</div>
</template>

<script>
  import WalletConstants from '@/constants/wallet';
  const type = WalletConstants.WalletTypeForExcel;

  export default {
    props: ['wallet'],
    data() {
      return{
        type
      }
    }
  }
</script>

